<template>
  <path
    d="M10.6471 18V13.7647H13.4706V18H17V12.3529H19.1176L12.0588 6L5 12.3529H7.11765V18H10.6471Z"
  />
</template>
